<template>
  <div class="breadcrumb-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in this.$route.matched"
        :key="index">
        {{ item.meta.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-radio-group
      @change="langChange"
      v-model="lang"
      size="mini">
      <el-radio-button label="zh-CN">简体</el-radio-button>
      <el-radio-button label="zh-TW">繁體</el-radio-button>
      <el-radio-button label="en">en</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
import { setLocalStorage, getLocalStorage } from '../../utils/utils';

export default {
  name: 'Breadcrumb',
  data() {
    return {
      lang: (getLocalStorage('lang') === null || getLocalStorage('lang') === '') ? 'zh-CN' : getLocalStorage('lang'),
    };
  },
  created() {
    setLocalStorage('lang', this.lang);
  },
  methods: {
    langChange() {
      setLocalStorage('lang', this.lang);
      location.reload(false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .breadcrumb-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E9E9E9;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Breadcrumb.vue